module.exports = __webpack_public_path__ + "static/media/con_spa_tri.0416663e.png";